export const GET_LOGO = "GET_LOGO";

export const SET_USER_DATA = "SET_USER_DATA";
export const GET_USER_DATA = "GET_USER_DATA";
export const CLEAR_DATA = "CLEAR_DATA";

export const SET_USER_BALANCE = "SET_USER_BALANCE";
export const GET_USER_BALANCE = "GET_USER_BALANCE";
export const CLEAR_DATA_BALANCE = "CLEAR_DATA_BALANCE";

export const SET_ORDERS = "SET_ORDERS";
export const SET_ORDER_DATA = "SET_ORDER_DATA";
export const GET_ORDERS = "GET_ORDERS";
export const CLEAR_ORDERS = "CLEAR_ORDERS";

